module.exports = __webpack_public_path__ + "static/media/mass-video-3.8569261d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/MassTest/mass-video-3.mp4
// module id = 3631
// module chunks = 0